export enum CreditAlgolyticsViewType {
    CREDIT = "credits",
    BANK_OFFERS = "banks_offers",
    PROPERTY = "property",
    RATING = "rating"
}
export enum CreditAlgolyticsViewType {
    CREDIT = "credits",
    BANK_OFFERS = "banks_offers",
    PROPERTY = "property",
    RATING = "rating"
}
